import {
    UPDATE_OCCUPIED_COST_ROOM_BREAKDOWN_VALUE,
    UPDATE_OCCUPIED_COST_FORM_VALUE,
    UPDATE_OCCUPIED_COST_SECTION,
    UPDATE_PACKAGE_CALCULATOR_FORM_VALUE,
    UPDATE_PACKAGE_CALCULATOR_INCLUSIONS_VALUE,
    UPDATE_PACKAGE_CALCULATOR_INCREMENTS,
    UPDATE_GROUP_DISPLACEMENT_FORM_VALUE,
    UPDATE_GROUP_DISPLACEMENT_ROOM_NUMBER,
    UPDATE_GROUP_DISPLACEMENT_ADR_DATA,
    UPDATE_GROUP_DISPLACEMENT_FORECAST_DATA,
    UPDATE_GROUP_DISPLACEMENT_ALL_FORECASTS,
    UPDATE_GROUP_DISPLACEMENT_ADDITIONAL_SPEND,
    UPDATE_GROUP_DISPLACEMENT_ADDITIONAL_SPEND_SECTION,
    GROUP_DISPLACEMENT_CALCULATE_MIN_RATE,
    GROUP_DISPLACEMENT_RESET_FORECASTS,
    UPDATE_GROUP_DISPLACEMENT_NORMAL_SPEND,
    LOAD_SAVE,
    LOAD_SAVE_START,
    LOAD_SAVE_SUCCESS,
    LOAD_SAVE_ERROR,
    RESET_LOADED_SAVE_STATE,
    RESET_FORM,
    FETCH_SAVES,
    FETCH_SAVES_START,
    FETCH_SAVES_SUCCESS,
    FETCH_SAVES_ERROR,
    RESET_SAVES_STATE,
    SAVE_FORM,
    SAVE_FORM_START,
    SAVE_FORM_SUCCESS,
    SAVE_FORM_ERROR,
    RESET_FROM_SAVING_STATE,
} from './constants';

export const updateRoomBreakdownValue = (fieldName, value) => ({
    type: UPDATE_OCCUPIED_COST_ROOM_BREAKDOWN_VALUE,
    fieldName,
    value,
});
export const updateFormValue = (sectionName, fieldId, actionType, value) => ({
    type: UPDATE_OCCUPIED_COST_FORM_VALUE,
    sectionName,
    fieldId,
    actionType,
    value,
});
export const updateAdditionalSpendFormValue = (fieldId, actionType, value) => ({
    type: UPDATE_GROUP_DISPLACEMENT_ADDITIONAL_SPEND,
    fieldId,
    actionType,
    value,
});
export const updateNormalSpendFormValue = (actionType, value) => ({
    type: UPDATE_GROUP_DISPLACEMENT_NORMAL_SPEND,
    actionType,
    value,
});
export const calculateMinRate = () => ({
    type: GROUP_DISPLACEMENT_CALCULATE_MIN_RATE,
});
export const updateAdditionalSpendSection = (enabled) => ({
    type: UPDATE_GROUP_DISPLACEMENT_ADDITIONAL_SPEND_SECTION,
    enabled,
});
export const updateSection = (sectionName, value) => ({
    type: UPDATE_OCCUPIED_COST_SECTION,
    sectionName,
    value,
});

export const updateGroupDisplacementProposals = (fieldName, value) => ({
    type: UPDATE_GROUP_DISPLACEMENT_FORM_VALUE,
    fieldName,
    value,
});
export const updateGroupDisplacementRoomNumber = (value) => ({
    type: UPDATE_GROUP_DISPLACEMENT_ROOM_NUMBER,
    value,
});
export const updateGroupDisplacementADRData = (data) => ({
    type: UPDATE_GROUP_DISPLACEMENT_ADR_DATA,
    data,
});
export const updateGroupDisplacementForecastData = (data, roomType) => ({
    type: UPDATE_GROUP_DISPLACEMENT_FORECAST_DATA,
    data,
    roomType,
});
export const updateGroupDisplacementAllForecasts = () => ({
    type: UPDATE_GROUP_DISPLACEMENT_ALL_FORECASTS,
});

export const updatePackageCalculatorProposals = (fieldName, value) => ({
    type: UPDATE_PACKAGE_CALCULATOR_FORM_VALUE,
    fieldName,
    value,
});

export const updatePackageCalculatorInclusions = (fieldId, actionType, value) => ({
    type: UPDATE_PACKAGE_CALCULATOR_INCLUSIONS_VALUE,
    fieldId,
    actionType,
    value,
});

export const updatePackageCalculatorIncrements = (fieldName, value) => ({
    type: UPDATE_PACKAGE_CALCULATOR_INCREMENTS,
    fieldName,
    value,
});

export const resetForm = () => ({ type: RESET_FORM });

export const resetForecasts = () => ({
    type: GROUP_DISPLACEMENT_RESET_FORECASTS,
});

export const loadSave = (saveID) => ({ type: LOAD_SAVE, params: { saveID } });
export const loadSaveStarted = (params) => ({ type: LOAD_SAVE_START, params });
export const loadSaveSucceeded = (data) => ({ type: LOAD_SAVE_SUCCESS, data });
export const loadSaveFailed = (error) => ({ type: LOAD_SAVE_ERROR, error });
export const resetLoadedSaveState = (error) => ({
    type: RESET_LOADED_SAVE_STATE,
    error,
});

export const fetchSaves = (type, propertyId, userId) => ({
    type: FETCH_SAVES,
    params: { type, propertyId, userId },
});
export const fetchSavesStarted = (params) => ({
    type: FETCH_SAVES_START,
    params,
});
export const fetchSavesSucceeded = (data) => ({
    type: FETCH_SAVES_SUCCESS,
    data,
});
export const fetchSavesFailed = (error) => ({ type: FETCH_SAVES_ERROR, error });
export const resetFetchedSavesState = () => ({ type: RESET_SAVES_STATE });

export const updateSave = (saveID, payload) => ({
    type: SAVE_FORM,
    params: { saveID, payload },
});
export const createSave = (type, propertyId, payload) => ({
    type: SAVE_FORM,
    params: { propertyId, type, payload },
});
export const saveFormStarted = (params) => ({
    type: SAVE_FORM_START,
    params,
});
export const saveFormSucceeded = (data) => ({
    type: SAVE_FORM_SUCCESS,
    data,
});
export const saveFormFailed = (error) => ({ type: SAVE_FORM_ERROR, error });
export const resetFormSavingState = () => ({ type: RESET_FROM_SAVING_STATE });
